export enum ImageServiceAspectRatio {
    ThirtyTwoByNine = "THIRTY_TWO_BY_NINE",
    SixteenByNine = "SIXTEEN_BY_NINE",
    OneByOne = "ONE_BY_ONE",
}
